import moment from "moment";

// serializer
import MessageTemplateSerializer from "issara-sdk/types/MessageTemplateSerializer_apps_PRX";
import PatientAppointmentSerializer from "issara-sdk/types/PatientAppointmentSerializer_apps_QUE";

import { formatDate } from "react-lib/utils/dateUtils";

import { CANCELLED_STATUS } from "./orderAppointmentModelV4";

/** TeleHealth ของผู้รับบริการ (pure) */

// ---------- นัด Telemedicine ----------

export type TeleAppointment = { time: string; doctor: string };

/** นัด telemed ของวันนี้ที่เร็วที่สุด */
export const todayTelemed = (
  appointments: PatientAppointmentSerializer[],
  today: moment.Moment,
): TeleAppointment | null => {
  const first = appointments
    .filter(
      (item) =>
        item.is_telemed &&
        !CANCELLED_STATUS.includes(item.status ?? 0) &&
        !!item.estimated_at_iso &&
        moment(item.estimated_at_iso).isSame(today, "day"),
    )
    .sort((a, b) => moment(a.estimated_at_iso).diff(moment(b.estimated_at_iso)))[0];

  if (!first) {
    return null;
  }

  return {
    time: moment(first.estimated_at_iso).format("HH:mm"),
    doctor: first.doctor_full_name ?? "",
  };
};

// ---------- ข้อความสำเร็จรูป ----------

/** ข้อความสำเร็จรูปที่เปิดใช้ ของหน่วยนี้ (divisions ว่าง = ทุกหน่วย) */
export const quickRepliesOf = (
  templates: MessageTemplateSerializer[],
  divisionId?: number,
): string[] =>
  templates
    .filter(
      (item) =>
        item.active !== false &&
        !!item.detail &&
        (item.divisions.length === 0 || (!!divisionId && item.divisions.includes(divisionId))),
    )
    .map((item) => item.detail ?? "");

// ---------- ไฟล์ในห้องแชท ----------

/** item ของ GET /apis/MSG/chat-channel/{id}/message/list/ */
export type ChatMessage = {
  id: number;
  content?: string;
  content_file?: string | null;
  content_type?: string;
  author?: { full_name?: string } | null;
  /** DD/MM/YYYY HH:mm (ค.ศ.) */
  send_at?: string;
};

export type TeleFile = {
  id: number;
  name: string;
  url: string;
  isImage: boolean;
  author: string;
  date: string;
  time: string;
};

const FILE_TYPES = ["image", "file"];

export const chatFilesOf = (messages: ChatMessage[]): TeleFile[] =>
  messages
    .filter((item) => FILE_TYPES.includes(item.content_type ?? "") && !!item.content_file)
    .map((item) => {
      const url = item.content_file ?? "";
      const sendAt = moment(item.send_at, "DD/MM/YYYY HH:mm");

      return {
        id: item.id,
        name: decodeURIComponent(url.split("?")[0].split("/").pop() ?? ""),
        url,
        isImage: item.content_type === "image",
        author: item.author?.full_name ?? "",
        date: formatDate(sendAt),
        time: sendAt.isValid() ? sendAt.format("HH:mm") : "",
      };
    });

// ---------- สาย Telemed ----------

/** url ของสายที่ยังไม่วาง (vid_call ล่าสุดที่ไม่มี end_call ตามหลัง) */
export const activeCallOf = (messages: ChatMessage[]): string | null => {
  let call: ChatMessage | null = null;
  let endId = 0;

  for (const item of messages) {
    if (item.content_type === "vid_call" && item.id > (call?.id ?? 0)) {
      call = item;
    }

    if (item.content_type === "end_call" && item.id > endId) {
      endId = item.id;
    }
  }

  return call && call.id > endId ? call.content || null : null;
};
